import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack, useTheme } from '@mui/material';
// mock
import account from '../../../_mock/account';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
//
import navConfig from './config';
import { setAuthorize } from '../../../redux/auth';
import { setNavConfig, setReadNavData, setWriteNavData } from 'src/redux/navs';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function Nav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  const dispatch = useDispatch()
  const isDesktop = useResponsive('up', 'lg');
  const theme = useTheme()
  const [navsConfig, setNavConfigs] = React.useState(navConfig)
  const user = useSelector(state => state?.auth)?.user
  const navigate = useNavigate()
  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);


  useEffect(() => {
    if (user?.accessLevel && user?.role == "staff") {
      let read = []
      let write = []
      let newConfig = []
      for (let i of navConfig) {
        console.log(user?.accessLevel)
        let d = user?.accessLevel[`${i.v}`]
        console.log(d)
        if (d?.read) {
          newConfig.push(i)
          read.push(i.v)
        }
        if (d?.write) {
          write.push(i.v)
        }
      }
      setNavConfigs(newConfig)
      dispatch(setReadNavData(read))
      dispatch(setWriteNavData(write))
      dispatch(setNavConfig(newConfig))

    } else {
      setNavConfigs(navConfig)
      dispatch(setReadNavData([]))
      dispatch(setWriteNavData([]))
    }
  }, [user])

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        <Logo />
      </Box>

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount>
            {/* <Avatar src={account.photoURL} alt="photoURL" /> */}
            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {user?.role?.toUpperCase()} ({user?.email})
              </Typography>
              {/* <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {account.role}
              </Typography> */}
            </Box>
          </StyledAccount>
        </Link>
      </Box>

      <NavSection data={navsConfig} />
      <Box sx={{ flexGrow: 1 }} />
      <Box onClick={() => {
        localStorage.clear()
        dispatch(setAuthorize(false))
      }} sx={{ display: "flex", justifyContent: "center", background: theme.palette.primary.light, py: 2, mt: 6, alignItems: "center" }}>
        <img src='/assets/icons/logout.png' style={{ height: "21px" }} alt='logout' />
        <Typography sx={{ fontSize: "20px", ml: 1 }} color="white" >Logout</Typography>
      </Box>

    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
